import React from "react";
import { Dropdown, Menu, message, Tooltip } from "antd";
import { PrinterOutlined } from "@ant-design/icons";
import { printfacdocpdf } from "../Services/PrintFacDocService";


const FacturePdf = ({ num_facture}) => {
  const exportToPDF = () => {
    const hideMessage = message.loading("Impression en cours...", 0);
    printfacdocpdf(num_facture);
    hideMessage(); // Masquer le message de chargement après la réussite
    message.success("Impression réussie!");
  };

  const handleExport = () => {
    exportToPDF();
  };

 

  return (
    <Tooltip title="PDF">
      <PrinterOutlined  size="small" style={{ cursor: 'pointer', color: '#67f02e', marginRight: 8 }} onClick={handleExport} />
    </Tooltip>
  );
};

export default FacturePdf;